import React from 'react';
import SearchSimple from "../../components/SearchSimples/SearchSimple";
import CustomTable from "../../components/table/CustomTable";
import CardsTableApp from "./Functionality/CardsTableApp";
import CustomButtonLink from "../../components/buttons/CustomButtonLink";

const CardsSectionTable = (props) => {
    const {
        isAllChecked,
        selectedList,
        setSelectedList,
        setBodyForExport,
        searchElement,
        setSearchElement,
        optionTable,
        setSearch,
        simpleSearch,
        setSimpleSearch,
        results,
        setResults,
        onAssignUnassign,
        onPreview,
        onDisassignTemplate,
        finalArray,
        setCriteria,
        modified,
        setModified,
        setIsAllChecked,
        canCreate,
        onCreate,
    } = props;

    const {
        t,
        tableId,
        searchId,
        thead,
        tbody,
        getActionsButtons,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        rowsPerPage,
        contractorId,
        supplierId,
        deletePermission,
        hasPermission
    } = CardsTableApp({
        selectedList,
        setSelectedList,
        onAssignUnassign,
        onPreview,
        onDisassignTemplate,
        setBodyForExport,
        modified,
        setModified,
        setIsAllChecked,
        searchElement,
        results,
        setResults
    });

    return (
        <div className={"row mt-4"}>
            <div className={"col-12 p-0"}>
                <SearchSimple
                    id={'txt_cst_search_cards'}
                    setBodyForExport={setBodyForExport}
                    setSearchResults={setResults}
                    searchResults={results}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    optionTable={optionTable}
                    rowsPerPage={rowsPerPage}
                    setSearch={setSearch}
                    simpleSearch={simpleSearch}
                    setSimpleSearch={setSimpleSearch}
                    contractorId={contractorId}
                    supplierId={supplierId}
                />
            </div>

            <div className={"col-12 p-0"}>
                <CustomTable tableId={tableId}
                             searchId={searchId}
                             checkbox={deletePermission}
                             checkboxTitle={"de_/_select_all"}
                             isAllChecked={isAllChecked}
                             onChangeCheckbox={handleDeleteAll}
                             thead={thead}
                             tbody={tbody}
                             columnActions={hasPermission}
                             getActionsButtons={getActionsButtons}
                             handleCheckboxChange={handleCheckboxChange}
                             selectedList={selectedList}
                             textNotInformation={'you_haven_not_created_any_card_yet'}
                             childrenNotInformation={tbody?.body?.length === 0 ? <>
                                     <div className={"warning-text"}>
                                         <p>{t('you_haven_not_created_any_card_yet')}</p>
                                     </div>
                                     { canCreate &&
                                         <CustomButtonLink splitName={false} id={'btn_cst_create'} card={true}
                                                           onClick={onCreate}
                                                           name={'create_new_card'}/>
                                     } </>
                                 : undefined
                             }
                />
            </div>

            { pagination() }
        </div>
    );
};

export default CardsSectionTable;
